module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/puzzle-4bde4084d90f9635442e68fcf97b7805.svg";